<app-multi-select-input
    [form]="form()"
    [id]="id()"
    [label]="'acl.group.labelMulti'"
    [showLabel]="showLabel()"
    valueKey="id"
    labelKey="name"
    filterBy="name"
    display="chip"
    [showClear]="true"
    [infiniteScroll]="itemScroll()"
    [disabled]="disabled()"
    [zIndex]="1005"
></app-multi-select-input>
